export { FeaturedEntity } from './FeaturedEntity';
